namespace advisorop.domains {
    
    export interface IRepFeeGroup {

        id?: number;

        companyGroupId?: number;

        name?: string;

        noFeesPermissionOnly?: boolean;

        isDeleted?: boolean;

        dateCreated?: Date;

        dateChanged?: Date;

        isDeletedDescription?: string;

        repNumber?: string;

        allocations?: Array<domains.IRepFeeGroupAllocation>;

        systemLoginCreated?: domains.identity.IUser;
    }

    export interface IRepFeeGroupAllocation {

        id?: number;

        percentage?: number;

        houseSplit?: number;

        advisorId?: number;

        repFeeGroupId?: number;

        repNumber?: string;

        advisor?: domains.IAdvisor;

        //this is not necesary 
        //repFeeGroup?: domains.IRepFeeGroup;
    }

    export class RepFeeGroupAllocation implements IRepFeeGroupAllocation {
        id?: number;

        percentage?: number;

        houseSplit?: number;

        advisorId?: number;

        repFeeGroupId?: number;

        advisor?: domains.IAdvisor;

        constructor() {
            this.houseSplitP = 0;
            this.percentageP = 0;
        };

        //houseSplitP: number property 
        get houseSplitP(): number {
            return parseFloat((this.houseSplit * 100).toFixed(2));
        }
        set houseSplitP(value: number) {            
            this.houseSplit = parseFloat((value / 100).toFixed(4));
        }

        //percentageP: number property 
        get percentageP(): number {
            return parseFloat((this.percentage * 100).toFixed(2));
        }
        set percentageP(value: number) {
            this.percentage = parseFloat((value / 100).toFixed(4));
        }
    }
}

